import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject ,Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ExpenseAttachmentsService {
    private apiUrl = environment.apiUrl + '/expense_attachments/';  // Usa la variable global
    private http = inject(HttpClient); // Inyección sin constructor


    private currentAttachmentId = new BehaviorSubject<any>(null)
    currentAttachmentId$ = this.currentAttachmentId.asObservable()

    setCurrentAttachmentId(attachmentId:any){
        this.currentAttachmentId.next(attachmentId)
    }

    get(): Observable<any[]> {
        return this.http.get<any[]>(this.apiUrl+'get');
    }
    getView(conceptResponseId:string): Observable<any[]> {
        let params = new HttpParams();
        params = params.append('conceptResponseId', conceptResponseId);
        return this.http.get<any[]>(this.apiUrl+'getView',{params:params});
    }
    getById(id: String): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}getById/${id}`);
    }
    save(formData:FormData): Observable<any> {
        return this.http.post<any>(this.apiUrl+'save',formData);
    }
    saveMany(formData:FormData): Observable<any> {
        return this.http.post<any>(this.apiUrl+'saveMany',formData);
    }
    update(id: String, expenseReport: any): Observable<any> {
        return this.http.put<any>(`${this.apiUrl}update/${id}`, expenseReport);
    }
    deleteAllByExpenseId(expenseId:string){
        return this.http.delete<any>(`${this.apiUrl+'deleteAllByExpense'}/${expenseId}`);
    }
}